export const IGEL_LOCALE_STORAGE_KEY = 'igel-collapsed'
